import Icon from '@assets/images/Hero-Icone.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './SegmentationFive.style';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SegmentationFive = () => {
  const { t } = useTranslation('segmentation');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('segmentationFive.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p>
            {t('segmentationFive.subtitle.spanBefore')}
            <span>2</span> {t('segmentationFive.subtitle.spanAfter')}
          </p>
          <ul>
            <li>{t('segmentationFive.ul.liOne')}</li>
            <li>{t('segmentationFive.ul.liTwo')}</li>
            <li>{t('segmentationFive.ul.liThree')}</li>
            <li>{t('segmentationFive.ul.liFour')}</li>
          </ul>
          <Link to="/contato" className="link-with-icon">
            <button>{t('segmentationFive.button')}</button>
          </Link>
        </TextBox1>
        <ImageBox>
          <img src={Icon} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SegmentationFive;
